import React, { useState } from 'react'
import Button from '@mui/material/Button'
import ButtonLoadingComponent from '../../../views/components/shared/ButtonLoadingComponent'
import { setNotification } from '../../components/ui-widgets/uiWidgetsSlice'
import { useAppDispatch } from '../../../app/hooks'
import { RtkQueryHelper } from '../../../api-services/shared/RtkQueryHelper'
import { type AssetHolderUpdateDto } from '../../../api-schema-types/asset-holdings/AssetHolderCrudDtos'
import AddModeratorIcon from '@mui/icons-material/AddModerator'
import {
  useLegacyApiAddIndividualKycResultMutation
} from '../../../api-services/asset-holdings/assetHolderApi'
import { Dialog, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'

interface ComponentProps {
  assetHolder: AssetHolderUpdateDto
}

const AddIndividualKYCComponent = (props: ComponentProps): JSX.Element => {
  const dispatch = useAppDispatch()
  const { assetHolder } = props

  const [isDialogOpen, toggleDialog] = useState<boolean>(false)
  const [referenceUrl, setReferenceUrl] = useState<string>('')

  const [apiAddKycResultTrigger, { isLoading }] = useLegacyApiAddIndividualKycResultMutation()

  const openDialog = (): void => {
    toggleDialog(true)
  }

  const handleResetKYC = (): void => {
    apiAddKycResultTrigger({
      assetHolderId: assetHolder.assetHolderId,
      status: 'PASSED',
      referenceUrl
    })
      .unwrap()
      .then(() => {
        dispatch(setNotification({ open: true, severity: 'success', message: 'Individual KYC added successfully.' }))
      })
      .catch((err) => {
        dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
      })
  }

  // const openConfirmDialog = (): void => {
  //   const choice = window.confirm(
  //     'Are you sure you want to add Individual KYC?'
  //   )
  //   if (choice) {
  //     handleResetKYC()
  //   }
  // }

  return (
    <React.Fragment>
      <Button
        variant={'outlined'}
        startIcon={<AddModeratorIcon />}
        onClick={() => { openDialog() }}
        disabled={assetHolder.latestLegacyKycResult?.status === null || assetHolder.latestLegacyKycResult?.status === undefined || assetHolder.latestLegacyKycResult?.status !== 'INCOMPLETE'}
      >
        Add Individual KYC
      </Button>

      <Dialog
        open={isDialogOpen}
        maxWidth={'md'}
        fullWidth={true}
        disableEscapeKeyDown={true}
        onClose={() => {
          toggleDialog(false)
        }}
      >
        <DialogTitle></DialogTitle>

        <DialogContent sx={{ p: 4 }}>
          <Grid container spacing={2}>
            <Grid item md={12}>
              <TextField
                label={'Reference URL'}
                name={'referenceUrl'}
                type={'text'}
                sx={{ width: '100%', mt: 2 }}
                placeholder={'Reference URL'}
                focused={true}
                onChange={(event) => {
                  setReferenceUrl(event.target.value)
                }}
              />
            </Grid>
            <Grid item>
              <Button
                variant={'contained'}
                type="button"
                disabled={isLoading}
                onClick={() => { handleResetKYC() }}
              >
                Submit
                {(isLoading) && <ButtonLoadingComponent/>}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant={'outlined'}
                type="button"
                disabled={isLoading}
                sx={{ ml: 2 }}
                onClick={() => { toggleDialog(false) }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}

export default AddIndividualKYCComponent
